var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 11V6.00195C11 5.44967 11.4477 5.00195 12 5.00195C12.5523 5.00195 13 5.44967 13 6.00195V11H17.998C18.5503 11 18.998 11.4477 18.998 12C18.998 12.5523 18.5503 13 17.998 13H13V17.998C13 18.5503 12.5523 18.998 12 18.998C11.4477 18.998 11 18.5503 11 17.998V13H6.00195C5.44967 13 5.00195 12.5523 5.00195 12C5.00195 11.4477 5.44967 11 6.00195 11H11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.6887e0b12752b5ef8efffa98235725aa.svg";
export { ForwardRef as ReactComponent };